import { Modal } from "@carbon6/c6-frontend-design";
import { useId, type ReactNode } from "react";
import { HatModalHeader } from "@/components/modal";
import { MemoPanel } from "./MemoPanel";
import { useMemoController } from "./useMemoController";
import styles from "./MemoDetailModal.module.css";

// 메모 전체 보기/작성 모달이다. 카드/스트립/팝업이 공유하는 full 편집 화면이다. 자체 controller 를
// 소유하고, open 일 때만 로드한다(닫혀 있으면 fetch 하지 않음). 작성/삭제 후 목록 갱신은
// controller 가 ListRefresh 컨텍스트로 처리한다(목록 밖이면 no-op).
export function MemoDetailModal({
  open,
  datasetUuid,
  title = "메모를 확인합니다.",
  canMutate = true,
  onClose,
}: {
  open: boolean;
  datasetUuid: string;
  title?: string;
  canMutate?: boolean;
  onClose: () => void;
}): ReactNode {
  const titleId = useId();
  const controller = useMemoController(datasetUuid, { enabled: open, canMutate });

  if (!open) {
    return null;
  }

  return (
    <Modal open onClose={onClose} size="md" aria-labelledby={titleId}>
      <HatModalHeader title={title} titleId={titleId} close />
      <div className={styles.body}>
        <MemoPanel controller={controller} />
      </div>
    </Modal>
  );
}
